import { render, staticRenderFns } from "./ReadActivity.vue?vue&type=template&id=3f4f0521&"
import script from "./ReadActivity.vue?vue&type=script&lang=js&"
export * from "./ReadActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports